import { useState } from 'react';
import LoginView from '../component/labeling/LoginView';
import QueueView from '../component/labeling/QueueView';
import PlayerView from '../component/labeling/PlayerView/PlayerView';
import TelemetryPlayerView from '../component/labeling/PlayerView/TelemetryPlayerView';
import IRRComparisonView from '../component/labeling/IRRComparisonView';
import ReplayModalView from '../component/labeling/PlayerView/ReplayModalView'

// Import all session files
import session_11155 from '../component/labeling/sessions/session_11155.json';
import session_11173 from '../component/labeling/sessions/session_11173.json';
import session_11197 from '../component/labeling/sessions/session_11197.json';
import session_11201 from '../component/labeling/sessions/session_11201.json';
import session_11217 from '../component/labeling/sessions/session_11217.json';
import session_11225 from '../component/labeling/sessions/session_11225.json';

// Create a mapping of session ID -> snapshot data
const snapshotsMap = {
  11155: session_11155,
  11173: session_11173,
  11197: session_11197,
  11201: session_11201,
  11217: session_11217,
  11225: session_11225,
};

export default function LabelingPage() {
  const [view, setView] = useState('login'); 
  const [currentUser, setCurrentUser] = useState('');
  const [selectedSession, setSelectedSession] = useState(null);
  const [irrSession, setIrrSession] = useState(null);

  const handleLogin = () => {
    setView('queue');
  };

  const handleLogout = () => {
    setCurrentUser('');
    setView('login');
  };

  const handleSelectSession = (session) => {
    setSelectedSession(session);
    setView('player');
  };

  const handleBackToQueue = () => {
    setView('queue');
  };

  const handleSubmitReview = () => {
    setView('queue');
  };

  const handleOpenIRR = (session) => {
    setIrrSession(session);
    setView('irr');
  };

  const handleCloseIRR = () => {
    setIrrSession(null);
    setView('queue');
  };

  return (
    <>
      {view === 'login' && (
        <LoginView 
          currentUser={currentUser}
          setCurrentUser={setCurrentUser}
          onEnter={handleLogin}
        />
      )}

      {view === 'queue' && (
        <QueueView 
          currentUser={currentUser}
          onLogout={handleLogout}
          onSelectSession={handleSelectSession}
          onOpenIRR={handleOpenIRR}
        />
      )}

      {view === 'player' && (
       ([7, 8, 9, 10, 11].includes(selectedSession?.batch)) ? (
          <ReplayModalView
            session={selectedSession}
            currentUser={currentUser}
            onBack={handleBackToQueue}
          />
        ) : selectedSession?.playerType === 'telemetry' ? (
          <TelemetryPlayerView 
            session={selectedSession}
            currentUser={currentUser}  
            onBack={handleBackToQueue}
            onSubmit={handleSubmitReview}
          />
        ) : (
          <PlayerView 
            session={{
              ...selectedSession,
              snapshotsJson: snapshotsMap[selectedSession?.id]
            }}
            currentUser={currentUser}  
            onBack={handleBackToQueue}
            onSubmit={handleSubmitReview}
          />
        )
      )}

      {view === 'irr' && (
        <IRRComparisonView 
          session={irrSession}
          onBack={handleCloseIRR}
        />
      )}
    </>
  );
}